import metamask from 'assets/icons/metamask_icon.svg'
import metamaskBrowser from 'assets/icons/metamask_browser_icon.svg'
import brave from 'assets/icons/brave_logo.svg'
import walletConnect from 'assets/icons/wallet_connect_icon.svg'
import trustWallet from 'assets/icons/trust_wallet_icon.svg'
import ethereum from 'assets/icons/eth_icon.svg'
import ethereumHole from 'assets/icons/eth_icon-hole.svg'
import polygon from 'assets/icons/polygon_icon.svg'
import solana from 'assets/icons/solana_icon.svg'
import block from 'assets/icons/block_icon.svg'
import cube from 'assets/icons/cube_white_icon.png'
import dollarCircle from 'assets/icons/dollar_circle.icon.svg'
import chain from 'assets/icons/chain_icon.svg'
import network from 'assets/icons/network_icon.svg'
import spinningBlock from 'assets/icons/spinning_block.gif'
import unstoppableDomain from 'assets/icons/unstoppableDomain_icon.png'
import coinbaseWallet from 'assets/icons/coinbaseWalletIcon.svg'
import doge from 'assets/icons/doge_icon.svg'
import tsla from 'assets/icons/tesla_icon.svg'
import tesla_icon_hole from 'assets/icons/tesla_icon-hole.svg'
import matic from 'assets/icons/matic_currency_icon.svg'
import maticHole from 'assets/icons/matic_currency_icon_hole.svg'
import gameStop from 'assets/icons/gamestop_icon.svg'
import bitcoin from 'assets/icons/bitcoin_icon.svg'
import bitcoinMask from 'assets/icons/btc_icon_mask.svg'
import usdc from 'assets/icons/usdc.svg'
import spy_icon from 'assets/icons/spy_icon.svg'
import spy_icon_transparent from 'assets/icons/spy_icon-transparent.svg'

export const crypto = {
  ethereum,
  ethereumHole,
  doge,
  tsla,
  tesla_icon_hole,
  metamask,
  metamaskBrowser,
  brave,
  walletConnect,
  trustWallet,
  polygon,
  solana,
  cube,
  block,
  dollarCircle,
  chain,
  network,
  spinningBlock,
  unstoppableDomain,
  coinbaseWallet,
  matic,
  maticHole,
  gameStop,
  bitcoin,
  bitcoinMask,
  usdc,
  spy_icon,
  spy_icon_transparent,
}


